/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderItemModel
 */
export interface OrderItemModel {
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    omsOrderItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    orderId?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    orderItemQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    orderItemStatusCode?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    subscriptionId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemModel
     */
    itemType?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemModel
     */
    updatedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemModel
     */
    updatedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemModel
     */
    isEquivalentMatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemModel
     */
    omsContactVet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemModel
     */
    deleted?: boolean;
}

/**
 * Check if a given object implements the OrderItemModel interface.
 */
export function instanceOfOrderItemModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderItemModelFromJSON(json: any): OrderItemModel {
    return OrderItemModelFromJSONTyped(json, false);
}

export function OrderItemModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'omsOrderItemId': !exists(json, 'omsOrderItemId') ? undefined : json['omsOrderItemId'],
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'orderItemQuantity': !exists(json, 'orderItemQuantity') ? undefined : json['orderItemQuantity'],
        'orderItemStatusCode': !exists(json, 'orderItemStatusCode') ? undefined : json['orderItemStatusCode'],
        'subscriptionId': !exists(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'itemType': !exists(json, 'itemType') ? undefined : json['itemType'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'isEquivalentMatch': !exists(json, 'isEquivalentMatch') ? undefined : json['isEquivalentMatch'],
        'omsContactVet': !exists(json, 'omsContactVet') ? undefined : json['omsContactVet'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function OrderItemModelToJSON(value?: OrderItemModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'omsOrderItemId': value.omsOrderItemId,
        'orderId': value.orderId,
        'orderItemQuantity': value.orderItemQuantity,
        'orderItemStatusCode': value.orderItemStatusCode,
        'subscriptionId': value.subscriptionId,
        'itemType': value.itemType,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'isEquivalentMatch': value.isEquivalentMatch,
        'omsContactVet': value.omsContactVet,
        'deleted': value.deleted,
    };
}

